import { render } from "./frame.vue?vue&type=template&id=e9115ff0&scoped=true"
import script from "./frame.vue?vue&type=script&lang=js"
export * from "./frame.vue?vue&type=script&lang=js"

import "./frame.vue?vue&type=style&index=0&id=e9115ff0&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9115ff0"]])

export default __exports__